import { DashboardHeader } from './DashboardHeader';
import { ActionItemsTable } from './ActionItemsTable';
import { CourtCalendar } from './CourtCalendar';
import { CourtDateList } from './CourtDateList';
import { ActivityTimeline } from './ActivityTimeline';

export function DashboardPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100/50">
      <div className="p-6 lg:p-8 max-w-7xl mx-auto space-y-5">
        {/* Header */}
        <DashboardHeader />

        {/* Action Items Table */}
        <ActionItemsTable />

        {/* Main Content Grid: Calendar | Court Dates | Activity */}
        <div className="grid grid-cols-1 lg:grid-cols-[auto_auto_1fr] gap-5 items-start">
          <CourtCalendar />
          <CourtDateList />
          <ActivityTimeline />
        </div>
      </div>
    </div>
  );
}

export default DashboardPage;
